export default __webpack_public_path__ + "static/img15h-d22e71a28574c9fdfdf290a14f12f8db.jpg";